export default __webpack_public_path__ + "daee79e09f58cc9c9d6d8bb3823711ea.svg";